import { Absent_getInstance3t0okspv6nz5y as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var PinnedPlayerInputClass;
function PinnedPlayerInput() {
  if (PinnedPlayerInputClass === VOID) {
    class $ {
      constructor(id, name, email, badge, callSignAdjective, callSignNoun, imageURL, avatarType, unvalidatedEmails, pins) {
        badge = badge === VOID ? Absent_getInstance() : badge;
        imageURL = imageURL === VOID ? Absent_getInstance() : imageURL;
        avatarType = avatarType === VOID ? Absent_getInstance() : avatarType;
        this.o72_1 = id;
        this.p72_1 = name;
        this.q72_1 = email;
        this.r72_1 = badge;
        this.s72_1 = callSignAdjective;
        this.t72_1 = callSignNoun;
        this.u72_1 = imageURL;
        this.v72_1 = avatarType;
        this.w72_1 = unvalidatedEmails;
        this.x72_1 = pins;
      }
      toString() {
        return 'PinnedPlayerInput(id=' + this.o72_1.toString() + ', name=' + this.p72_1 + ', email=' + this.q72_1 + ', badge=' + toString(this.r72_1) + ', callSignAdjective=' + this.s72_1 + ', callSignNoun=' + this.t72_1 + ', imageURL=' + toString(this.u72_1) + ', avatarType=' + toString(this.v72_1) + ', unvalidatedEmails=' + toString(this.w72_1) + ', pins=' + toString(this.x72_1) + ')';
      }
      hashCode() {
        var result = this.o72_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.p72_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.q72_1) | 0;
        result = imul(result, 31) + hashCode(this.r72_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.s72_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.t72_1) | 0;
        result = imul(result, 31) + hashCode(this.u72_1) | 0;
        result = imul(result, 31) + hashCode(this.v72_1) | 0;
        result = imul(result, 31) + hashCode(this.w72_1) | 0;
        result = imul(result, 31) + hashCode(this.x72_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PinnedPlayerInput()))
          return false;
        if (!this.o72_1.equals(other.o72_1))
          return false;
        if (!(this.p72_1 === other.p72_1))
          return false;
        if (!(this.q72_1 === other.q72_1))
          return false;
        if (!equals(this.r72_1, other.r72_1))
          return false;
        if (!(this.s72_1 === other.s72_1))
          return false;
        if (!(this.t72_1 === other.t72_1))
          return false;
        if (!equals(this.u72_1, other.u72_1))
          return false;
        if (!equals(this.v72_1, other.v72_1))
          return false;
        if (!equals(this.w72_1, other.w72_1))
          return false;
        if (!equals(this.x72_1, other.x72_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'PinnedPlayerInput');
    PinnedPlayerInputClass = $;
  }
  return PinnedPlayerInputClass;
}
//region block: exports
export {
  PinnedPlayerInput as PinnedPlayerInput1hnlnl1bk4or8,
};
//endregion

//# sourceMappingURL=PinnedPlayerInput.mjs.map
